import { render, staticRenderFns } from "./AllPlanets.vue?vue&type=template&id=01500ebe"
import script from "./AllPlanets.vue?vue&type=script&lang=js"
export * from "./AllPlanets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports